export default "__VITE_ASSET__CDAOoqGg__"